import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Trophy, Crown, Medal } from "lucide-react";
import { api, fmtDate } from "@/lib/api";
import { ChartBoard } from "@/components/fo/ChartBoard";
import { SectionHead } from "@/components/fo/Bits";

const PRIZES = [
  [Crown, "Blind Chart #1", "Published interview, home cover for 7 days, 1 month Pro, permanent Blind #1 badge."],
  [Trophy, "Fan Chart #1", "1 month Pro, Fan Favourite badge and a free radio premiere."],
  [Medal, "Top 3 of each chart", "1 month of the Artist plan free (or an extension if you already subscribe)."],
  [Crown, "Artist of the Month", "Most weeks on a podium in the month: magazine feature, a daily prime-time slot for 30 days and a permanent badge."],
];

const Winners = ({ last }) => {
  const rows = [["Blind", last?.blind?.[0]], ["Fan", last?.fan?.[0]]].filter(([, r]) => r);
  if (!rows.length) return null;
  return (
    <div className="mt-10 grid gap-4 md:grid-cols-2">
      {rows.map(([k, r]) => (
        <Link key={k} to={`/a/${r.artist.slug}`} className="panel flex items-center gap-4 p-5 hover:border-[#FFB800]/50" data-testid={`last-week-winner-${k.toLowerCase()}`}>
          <Crown className="h-8 w-8 text-[#FFB800]" />
          <div><div className="label-mono !text-[#FFB800]">Last week · {k} #1</div><div className="font-display text-xl font-bold">{r.title} — {r.artist.stage_name}</div></div>
        </Link>
      ))}
    </div>
  );
};

export default function Charts() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/charts").then((r) => setD(r.data)); }, []);
  return (
    <div className="mx-auto max-w-5xl px-4 pb-24 pt-28 md:px-8" data-testid="charts-page">
      <SectionHead label={d ? `Week ${fmtDate(d.week_start)} → ${fmtDate(d.week_end)}` : "Weekly Chart"} title="Weekly Chart">
        Two boards, one week, reset every Monday. The Blind Chart counts only Flames given while the artist name was hidden — no follower army can buy it.
      </SectionHead>
      <ChartBoard data={d} limit={20} />
      <Winners last={d?.last_week} />
      <Link to="/weekly" className="btn-ghost mt-6" data-testid="charts-weekly-recap-link">Last week's recap →</Link>
      <div className="mt-20">
        <SectionHead label="Prizes" title="What winners get" >No cash prizes — visibility that actually moves careers.</SectionHead>
        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
          {PRIZES.map(([I, t, s]) => <div key={t} className="panel p-6"><I className="h-7 w-7 text-[#FFB800]" /><h3 className="mt-4 font-display text-xl font-bold">{t}</h3><p className="mt-2 text-sm text-slate-400">{s}</p></div>)}
        </div>
      </div>
    </div>
  );
}
